import { render } from "./menu_sidebar.html?vue&type=template&id=2a7a7824&scoped=true&external"
import script from "./menu_sidebar.js?vue&type=script&lang=js&external"
export * from "./menu_sidebar.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=2a7a7824&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7a7824"]])

export default __exports__